import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import * as AppPropTypes from '../../lib/PropTypes';

import styles from '../../../styles/partials/address.module.scss';

const propTypes = {
    address: AppPropTypes.address.isRequired,
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const Address = ({ address, className }) => {
    const {
        name = null,
        street = null,
        city = null,
        country = null,
        zipCode = null,
    } = address || {};
    return (
        <ul
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            {name !== null ? <li className={styles.name}>{name}</li> : null}
            {street !== null ? <li>{street}</li> : null}
            {city !== null ? <li>{city}</li> : null}
            {country !== null ? <li>{country}</li> : null}
            {zipCode !== null ? <li>{zipCode}</li> : null}
        </ul>
    );
};

Address.propTypes = propTypes;
Address.defaultProps = defaultProps;

export default Address;
